import React from 'react';
import { useInterface } from '../../context/InterfaceProvider';
import SciFiIcon from './SciFiIcon';
import { RocketArt } from './SpaceArt';
import styles from './SimplePanelHeading.module.css';

function PanelAccent({ kind }) {
  const id = React.useId();
  if (kind === 'sold') return <RocketArt />;
  const colors = { card: ['#ffb8df', '#fa507b', '#6d327e'], grading: ['#e395ff', '#9c49e7', '#30227e'], cost: ['#fff1a3', '#ffc350', '#b87322'], misc: ['#99ffad', '#39d8a2', '#116a8e'], tags: ['#85eaff', '#198de4', '#143b8d'] };
  const palette = colors[kind] || colors.tags;
  return <svg viewBox="0 0 48 48" fill="none" aria-hidden="true" focusable="false">
    <defs><radialGradient id={id} cx="30%" cy="22%" r="80%"><stop stopColor={palette[0]} /><stop offset=".45" stopColor={palette[1]} /><stop offset="1" stopColor={palette[2]} /></radialGradient></defs>
    <circle cx="24" cy="24" r="19" fill={`url(#${id})`} />
    {kind === 'cost' ? <><path d="m20 6 3-4 3 4 4-3-2 8H20l-2-8 2 3Z" fill="#ffe79c" /><path d="M29 18c-9-5-14 6-5 6s5 11-4 6m4-16v20" stroke="#82551b" strokeWidth="3" strokeLinecap="round" /></> : kind === 'card' ? <><path d="M6 24h36" stroke="#092747" strokeWidth="4" /><circle cx="24" cy="24" r="6" fill="#dffaff" stroke="#092747" strokeWidth="3" /></> : <><ellipse cx="17" cy="15" rx="5" ry="6" fill={palette[2]} opacity=".65" /><circle cx="31" cy="28" r="5" fill={palette[2]} opacity=".65" /><circle cx="17" cy="33" r="3" fill={palette[2]} opacity=".55" /><circle cx="31" cy="13" r="2" fill="#dcffff" opacity=".7" /></>}
    <path d="M10 18a15 15 0 0 1 9-9" stroke="#e0ffff" strokeOpacity=".65" strokeWidth="2" strokeLinecap="round" />
  </svg>;
}

export function SimpleTabLabel({ kind, children }) {
  const { version } = useInterface();
  if (version !== 'simple') return <>{children}</>;
  return <span className={styles.tabLabel}><SciFiIcon kind={kind} className={styles.tabIcon} /><span>{children}</span></span>;
}

export default function SimplePanelHeading({ kind, children }) {
  const { version } = useInterface();
  if (version !== 'simple') return <>{children}</>;
  return (
    <span className={styles.heading}>
      <SciFiIcon kind={kind} className={styles.icon} />
      <span>{children}</span>
      <span className={styles.accent} aria-hidden="true"><PanelAccent kind={kind} /></span>
    </span>
  );
}
